
import { Component, Vue } from 'vue-property-decorator'
import { NavBar } from '@/components'
import draggable from 'vuedraggable'
import FetchWrapper from '@/classes/fetchWrapper'

@Component({
  components: {
    draggable,
    NavBar
  }
})
export default class TaskRankExpView extends Vue {
  data () {
    return {
      taskId: null,
      taskdata: {},
      unscoredWords: [],
      unkownWords: [],
      kindKnownWords: [],
      knownWords: [],
      isDragging: false,
      delayedDragging: false,
      disabled: true,
      remainTime: ''
    }
  }

  mounted () {
    this.taskId = this.$route.query.id
    this.getTaskData()
    // this.updateOrderIndexes()
  }

  get isLoggedIn () {
    return this.$store.state.loggedIn
  }

  fillRemainTime (due) {
    if (due) {
      var now = new Date()
      var days = (due.valueOf() - now.valueOf()) / (1000 * 3600 * 24)
      if (days <= 0) {
        this.remainTime = 'Expired'
      } else {
        var hours = (days - Math.floor(days)) * 24
        var mins = 0
        if ((hours - Math.floor(hours)) > 0) {
          mins = (hours - Math.floor(hours)) * 60
        }
        var daysString = days < 10 ? days < 1 ? '' : `0${Math.floor(days)} Days and ` : `${Math.floor(days)} Days and `
        var hoursString = hours < 10 ? `0${Math.floor(hours)}` : Math.floor(hours)
        var minsString = mins < 10 ? `0${Math.floor(mins)}` : Math.floor(mins)

        this.remainTime = `${daysString}${hoursString}:${minsString} h `
      }
    } else {
      this.remainTime = ''
    }
  }

  onMove ({ relatedContext, draggedContext }) {
    const relatedElement = relatedContext.element
    const draggedElement = draggedContext.element
    return (
      (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
    )
  }

  onChange ({ moved }) {
    // const { newIndex, oldIndex, element } = moved
    // this.updateOrderIndexes()
  }

  /* updateOrderIndexes () {
    this.words.map((item, idx) => {
      item.order = idx + 1
      return 0
    })
  } */

  async getTaskData () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getTaskData/${this.taskId}`))
      var words = JSON.parse(resp.data).dicionarios
      this.knownWords = words.filter(item => item.score >= 70)
      this.kindKnownWords = words.filter(item => item.score < 70 && item.score >= 25)
      this.unkownWords = words.filter(item => item.score < 25 && item.score >= 0 && item.score !== null)
      this.unscoredWords = words.filter(item => item.score === null)
      this.taskData = resp
      this.disabled = this.taskData.completed || new Date(resp.due) <= new Date()
      this.fillRemainTime(new Date(resp.due))
      this.isLoading = false
      // this.updateOrderIndexes()
      // console.log(`this.`)
    } catch (e) {
      this.taskData = {}
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get task data.',
        canCancel: false
      })
    }
  }

  async save () {
    await this.updateOnServer(false)
  }

  displayModalFinish () {
    this.$buefy.dialog.confirm({
      title: 'Are you sure?',
      message: 'By confirming, you won`t be able to change it back.',
      onConfirm: () => {
        this.finish()
      },
      canCancel: true
    })
  }

  async finish () {
    await this.updateOnServer(true)
  }

  async updateOnServer (completed) {
    this.isLoading = true
    var dicionarios = []
    this.knownWords.map(item => {
      if (item.score < 70 || !item.score) {
        item.score = 70
      }
      dicionarios.push(item)
      return 0
    })
    this.kindKnownWords.map(item => {
      if (item.score < 25 || item.score >= 70 || !item.score) {
        item.score = 25
      }
      dicionarios.push(item)
      return 0
    })
    this.unkownWords.map(item => {
      if (item.score >= 25 || !item.score) {
        item.score = 0
      }
      dicionarios.push(item)
      return 0
    })

    this.unscoredWords.map(item => {
      item.score = null
      dicionarios.push(item)
      return 0
    })
    const resp = await FetchWrapper.post(
      `${process.env.VUE_APP_SERVERURL}/updateRankExpTaskData`,
      {
        data: JSON.stringify({ dicionarios }),
        id: Number(this.taskId),
        completed
      }
    )
    this.isLoading = false
    if (resp.error || resp.statusCode) {
      this.$buefy.dialog.confirm({
        title: 'Error while saving.',
        message: resp.error,
        canCancel: false
      })
    } else {
      this.$buefy.dialog.confirm({
        title: 'Success',
        message: 'Task saved Successfully',
        onConfirm: () => {
          if (completed) {
            window.location.href = '/home/tasks'
          }
        },
        canCancel: false
      })
    }
  }
}
